<template>
  <div>
    <Form ref="tagForm" :model="tagInfo" :label-width="120">
      <div class="title">设置信息</div>
      <FormItem label="讲师评价标签">
        <Tag
          type="border"
          :closable="editable"
          v-for="(tag,index) in tagInfo.tags"
          :key="index"
          @on-close="removeTag(index)"
        >{{tag.title}}</Tag>
        <Button icon="ios-add" v-if="editable" @click="showTagModal=true"></Button>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" type="primary" v-if="!editable" @click="editable=true">编辑</Button>
        <Button size="large" type="primary" @click="saveTags" v-if="editable">保存</Button>
      </FormItem>
    </Form>
    <Modal v-model="showTagModal" :width="500" title="添加标签">
      <Form ref="tagEditForm" :rules="ruleValidate" :model="tagEditInfo" :label-width="120">
        <FormItem label="标签名称" prop="title">
          <Input
            style="width:300px"
            type="text"
            v-model="tagEditInfo.title"
            placeholder="请输入标签名称"
            :maxlength="50"
          />
        </FormItem>
      </Form>
      <template slot="footer">
        <div style="text-align:right;">
          <Button size="large" type="default" @click="showTagModal=false">取消</Button>
          <Button size="large" type="primary" @click="submitEditForm('tagEditForm')">确定</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "TeachOtoTag",
  data() {
    return {
      editable: false,
      showTagModal: false,
      tagInfo: {
        tags: [],
        removeTagIds: []
      },
      tagEditInfo: {
        title: ""
      },
      ruleValidate: {
        title: [
          {
            required: true,
            message: "标签名称不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.tagInfo.tags = await this.$http.get("/api/oto/flag/list");
    },
    removeTag(index) {
      this.tagInfo.tags.splice(index, 1);
    },
    submitEditForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        this.showTagModal = false;
        this.tagInfo.tags.push({ title: this.tagEditInfo.title });
        this.tagEditInfo.title = "";
      });
    },
    async saveTags() {
      let newTags = this.tagInfo.tags;
      let flag = 1;
      if (newTags.length > 0) {
        let titles = [];
        newTags.forEach(t => {
          titles.push(t.title);
        });
        await this.$http.post("/api/oto/flag/addFlag", {
          title: titles.join(","),
          flag: flag
        });
        await this.$promiseConfirm("是否保存更改？", "提示", {
          okText: "保存更改",
          cancelText: "暂不更改",
          onCancel: async () => {
            this.editable = false;
            await this.getList();
          }
        });
        flag = 0;
        await this.$http.post("/api/oto/flag/addFlag", {
          title: titles.join(","),
          flag: flag
        });
      } else {
        this.$Message.error("至少保留一个标签");
        return;
      }
      this.editable = false;
      this.$Message.saveSuccess();
    }
  }
};
</script>
